class Filter {
  constructor(filterEl) {
    this.selector = 'body';
    this.filter = filterEl;
    this.filterAttributes = filterEl.data('filters-ids').split(',');
    this.dataContainerClass = filterEl.data('to-be-filtered-parent-selector');
    this.clickableParentSelector = filterEl.data('filters-clickable-item-parent-selector');
    this.clickableSelector = filterEl.data('filters-clickable-item-selector');
    this.placeholder = filterEl.data('filters-placeholder');
    this.limit = $(window).width() < 1024 ? filterEl.attr('data-show-on-mobile') : filterEl.attr('data-show-on-desktop');
    this.showMoreSelector = filterEl.attr('data-show-more-selector');
    this.bootstrap();
  }

  bootstrap() {
    this.runDirectives();
  }

  runDirectives() {
    if (this.filter.length === 0) {
      return;
    }

    const { filter, clickableSelector, dataContainerClass, filterAttributes, placeholder } = this;
    const attributesValue = {};

    filterAttributes.forEach(attribute => {
      const dataElement = filter.find(`[data-${attribute}]`);

      attributesValue[attribute] = [];
      dataElement.each(function () {
        if (!attributesValue[attribute].includes($(this).data(attribute))) {
          attributesValue[attribute].push($(this).data(attribute));
        }
      });

      let clickableElements = '';

      attributesValue[attribute].sort().forEach(el => {
        clickableElements += `<a class="${clickableSelector.replace('.', '')}" data-value="${el}" href="#">${el}</a>`;
      });
      $(`#${attribute}`).find(`${this.clickableParentSelector}`).append(clickableElements);

      Filter.filterData(filter, dataContainerClass, filterAttributes);
      filter.find(`#${attribute} ${clickableSelector}`).on('click', function (event) {
        event.preventDefault();
        filter.attr(`data-filter-${attribute}`, $(this).data('value'));
        const placeholdertext = $(this).data('value') !== '*' ? $(this).data('value') : $(this).text();

        $(this).closest(`#${attribute}`).find(`${placeholder}`).text(placeholdertext);
        Filter.filterData(filter, dataContainerClass, filterAttributes);
      });
    });

    Filter.showMore(this.showMoreSelector, this.limit);
  }

  static filterData(filter, dataSelector, attributes = []) {
    let visibleElements = 0;
    const limit = $(window).width() < 1024 ? filter.attr('data-show-on-mobile') : filter.attr('data-show-on-desktop');
    const showMoreSelector = filter.attr('data-show-more-selector');
    const noResultSelector = filter.attr('data-no-results-selector');
    const showMoreButton = filter.find(`${showMoreSelector}`);
    const notShowingClass = 'not-showing';

    $(dataSelector).children().each(function () {
      const child = $(this);
      const isHidden = Filter.isHidden(filter, attributes, child);

      if (isHidden === 'hidden') {
        child.removeClass(notShowingClass).hide();
      } else {
        child.removeClass(notShowingClass).show();
        visibleElements += 1;
        if (visibleElements > limit) {
          child.addClass(notShowingClass).hide();
        }
      }
    });
    Filter.showHideMoreButton(filter, visibleElements, limit, showMoreButton, noResultSelector);
  }

  static isHidden(filter, attributes, child) {
    let isHidden = true;

    attributes.forEach(attr => {
      const filterValue = filter.attr(`data-filter-${attr}`);

      if (typeof filterValue !== 'undefined') {
        if (isHidden !== 'hidden' && (child.attr(`data-${attr}`) === filterValue || filterValue === '*')) {
          isHidden = 'visible';
        } else {
          isHidden = 'hidden';
        }
      }
    });

    return isHidden;
  }

  static showHideMoreButton(filter, visibleElements, limit, showMoreButton, noResultSelector) {
    if (visibleElements > limit) {
      showMoreButton.show();
    } else {
      showMoreButton.hide();
    }
    if (visibleElements === 0) {
      filter.find(`${noResultSelector}`).show();
    } else {
      filter.find(`${noResultSelector}`).hide();
    }
  }

  static showMore(selector, limit) {
    const notShowingClass = 'not-showing';

    $(selector).on('click', function () {
      const filter = $(this).closest('[data-filters-ids]');
      const dataParentSelector = filter.attr('data-to-be-filtered-parent-selector');
      let opened = 0;

      filter.find(`${dataParentSelector}`).children().each(function () {
        if ($(this).hasClass(notShowingClass) && opened < limit) {
          $(this).removeClass(notShowingClass).show();
          opened += 1;
        }
      });
      if (filter.find(`${notShowingClass}`).length === 0) {
        $(this).hide();
      }
    });
  }
}

export default function () {
  this.selector = 'body';
  this.bootstrap = function () {
    $('[data-to-be-filtered-parent-selector]').each(function () {
      const filter = $(this);

      filter.data('af-filter', new Filter(filter));
    });
  };
}
